import dynamic from 'next/dynamic';
const FeaturedProducts = dynamic(() => import('./FeaturedProducts'));
export default FeaturedProducts;
